import DateInput from "./dateInput.tsx";
import Input from "./input.tsx";

type Props = {
  name: string;
  label: string;
  placeholder?: string;
  prefix?: string;
  type?: "text" | "date";
};

export default function FormInput({
  name,
  label,
  placeholder,
  prefix,
  type = "text",
}: Props) {
  return (
    <div className="sm:col-span-4">
      <label
        htmlFor={name}
        className="block text-sm font-medium leading-6 text-gray-900"
      >
        {label}
      </label>
      <div className="mt-1">
        {type === "text" ? (
          <Input name={name} placeholder={placeholder} prefix={prefix} />
        ) : (
          <DateInput name={name} placeholder={placeholder} />
        )}
      </div>
    </div>
  );
}
